import axios from 'axios';

// staging
// export const BASE_URL = 'https://reg247.tddev.site:3000/api/v1/user/';

// live
// export const BASE_URL = 'https://reg247.co.uk:8443/api/v1/user/';
// export const BASE_URL = 'http://35.179.153.160/api/v1/user/';
export const BASE_URL = 'https://www.reg247.co.uk/api/v1/user/';

//local
// export const BASE_URL = 'http://192.168.29.59:8443/api/v1/user/';

export const API = (url, method, data, token) => {
  return new Promise((resolve, reject) => {
    if (data) {
      axios({
        url: `${BASE_URL}${url}`,
        method: method,
        data: data,
        headers: token
          ? {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            }
          : {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
      })
        .then((res) => {
          // console.log("res: ", res);
          return resolve(res.data);
        })
        .catch((error) => {
          return reject(error);
        });
    } else {
      axios({
        url: `${BASE_URL}${url}`,
        method: method,
        // data: data,
        headers: token
          ? {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            }
          : {
              // "Accept": "application/json",
              'Content-Type': 'application/json',
            },
      })
        .then((res) => {
          // console.log("res: ", res);
          return resolve(res.data);
        })
        .catch((error) => {
          return reject(error);
        });
    }
  });
};

export const verifySite = (token) => {
  if (token) {
    API('recaptcha', 'post', {response: token}, '')
      .then((res) => {
        console.log('site verification res: ', res);
      })
      .catch((error) => console.log('site verification error: ', error));
  }
};
